const TermsAndConditionsData = [
    {
        title: "1. User Registration and Account Security",
        description:
            "To access some features of the GEM website, you must register for an account. When you register for an account, you may be required to provide us with some personal information such as your name, email address, and other contact information. You agree that the information you provide to us is accurate and complete, and you will keep your account information up-to-date. You are responsible for maintaining the confidentiality of your account login information and password. You agree to notify GEM immediately of any unauthorized use of your account or any other breach of security."
    },
    {
        title: "2. User-Generated Content",
        description:
            "GEM allows users to upload and share their own content such as images, videos, and other media. By submitting content to GEM, you represent and warrant that you have all necessary rights and permissions to use and share such content, and that your content does not infringe on any third-party rights. You agree that GEM may use your content in connection with our services and for marketing purposes. You grant GEM a worldwide, non-exclusive, royalty-free, transferable license to use, copy, modify, create derivative works based on, distribute, publicly display, publicly perform, and otherwise exploit in any manner such content in all formats and distribution channels now known or hereafter devised."
    },
    {
        title: "3. Data Collection and Privacy",
        description:
            "GEM collects and uses personal information as described in our Privacy Policy. By using our website, you agree to our collection and use of your personal information as described in our Privacy Policy."
    },
    {
        title: "4. Payments",
        description:
            "Certain features of GEM may require payment. By using these features, you agree to pay all fees and charges incurred in connection with your use of such features. You also agree to provide accurate and complete billing information, including your full name, address, and payment information."
    },
    {
        title: "5. Intellectual Property Rights",
        description:
            "The content on the GEM website, including text, graphics, logos, images, and other materials, is protected by copyright, trademark, and other intellectual property laws. You agree not to copy, reproduce, modify, or create derivative works based on such content without our express written consent."
    },
    {
        title: "6. Termination",
        description:
            "GEM may terminate or suspend your access to all or any part of our website at any time, with or without cause, with or without notice. Upon termination, all licenses and other rights granted to you in these terms of use will immediately cease."
    },
    {
        title: "7. Disclaimer of Warranties",
        description:
            "GEM makes no representations or warranties of any kind, express or implied, as to the operation of our website or the information, content, materials, or products included on our website. You use our website at your own risk."
    },
    {
        title: "8. Limitation of Liability",
        description:
            "GEM will not be liable for any damages of any kind arising from the use of our website, including, but not limited to, direct, indirect, incidental, punitive, and consequential damages."
    },
    {
        title: "9. Governing Law",
        description:
            "These terms of use will be governed by and construed in accordance with the laws of the state of [state], without giving effect to any principles of conflicts of law."
    },
    {
        title: "10. Changes to These Terms",
        description:
            "GEM reserves the right to modify these terms of use at any time, with or without notice. Your continued use of our website after any changes to these terms of use will constitute your acceptance of such changes."
    }
];

export default TermsAndConditionsData;
